import React, { useState } from "react"
import CardWrapper from "./CardWrapper"
import PassengersImg from "../../../../assets/avia/search/passagers.png"
import PassengerModal from "./PassengerModal"
import { useTranslation } from "react-i18next"
import CurrencySelector from "../../CurrencySelector"

const FormPassengersCard = ({
  passengers,
  onPassengersChange,
  currency,
  currencies,
  onCurrencyChange,
}) => {
  const { t } = useTranslation()
  const [isOpenModal, setIsOpenModal] = useState(false)

  const handleUpdate = (type, value) => {
    const updated = { ...passengers, [type]: value }
    onPassengersChange(updated)
  }

  const totalCount = passengers.adults + passengers.children + passengers.infants

  return (
    <CardWrapper minW="110">
      <div
        onClick={() => setIsOpenModal((prev) => !prev)}
        className="flex items-center gap-4 h-[45px] overflow-visible relative cursor-pointer"
      >
        <img src={PassengersImg} alt="passenger card icon" />
        <div className="flex flex-col text-sm whitespace-nowrap">
          <span className="text-app-content-subtle">{t("admin.passengers")}</span>
          <span className="text-black">{totalCount}</span>
        </div>
      </div>
      <PassengerModal
        showModal={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        passengers={passengers}
        onUpdate={handleUpdate}
      />
      <CurrencySelector
        currencies={currencies}
        currency={currency}
        onChange={onCurrencyChange}
        additionalClasses="absolute sm:hidden"
      />
    </CardWrapper>
  )
}

export default FormPassengersCard
